module.exports = __webpack_public_path__ + "img/07_no.ea709905.svg";